import React from 'react'
import { SingleVisitImg, Web, Res, TopImage, BottomImage}  from '../../../../../images/index'

function SingleVisitSlider() {
  
  return (
    <div className="relative bg-bgDark w-screen h-screen flex flex-row justify-center align-middle">      
      {/* Desktop version */}
      <div className='hidden lg:block w-full max-w-7xl relative my-24 lg:mx-16 xl:mx-24'>
        <div className={`absolute top-0 right-0 z-10`}>
          <img src={TopImage} className={`h-72 object-contain`}/>
        </div>
        <div className={`absolute bottom-0 right-0 z-10`}>
          <img src={BottomImage} className={`h-72 object-contain`}/>
        </div>
        <img src={Web} className="p-6 h-full my-auto inset-0 absolute object-contain"/>
      </div>
      {/* Smaller version */}
      <div className='block lg:hidden w-full relative sm:mx-12 my-24 md:m-24'>
        <div className={`absolute mr-2 sm:mr-0 bottom-0 right-0 z-10`}>
          <img src={TopImage} className={`h-52 object-contain`}/>
        </div>
        <div className={`absolute ml-2 sm:ml-0 bottom-0 left-0 z-10`}>
          <img src={BottomImage} className={`h-52 object-contain`}/>
        </div>
        <img src={Res} className="p-6 h-full my-auto inset-0 absolute object-contain"/> 
      </div>
      {/* Centered content */}
      <div className={`flex transform -translate-y-20 sm:-translate-y-24 sm:translate-x-12 lg:translate-y-0 lg:-translate-x-16 xl:-translate-x-24 absolute inset-0 flex-row justify-center align-middle text-left`} /* style={TEXT_STYLE} */>
        <div className="flex w-62 sm:w-96 flex-col my-auto">
          <h1 className="text-left text-white text-base sm:text-xl lg:text-3xl font-semibold my-2">Your smile can uplift your life</h1>
          <div className={` font-sans text-white`}>
            <h2 className="text-left text-base font-semibold lg:text-xl font-sans text-white my-2">Simply Prep&Place*</h2>
            <div className='my-2 mx-auto lg:mx-0 lg:my-4 w-32 border border-gray-300'/>
            <ul>
              <li className="my-1 text-base lg:text-lg"><span className="text-white lg:text-base font-extrabold mr-1">&#x2022;</span>optimized AI prep-assistance</li>
              <li className="my-1 text-base lg:text-lg"><span className="text-white lg:text-base font-extrabold mr-1">&#x2022;</span>no messy impressions</li>
              <li className="my-1 text-base lg:text-lg"><span className="text-white lg:text-base font-extrabold mr-1">&#x2022;</span>no metal fillings</li>
              <li className="my-1 text-base lg:text-lg"><span className="text-white lg:text-base font-extrabold mr-1">&#x2022;</span>no temporaries</li>
              <li className="my-1 text-base lg:text-lg"><span className="text-white lg:text-base font-extrabold mr-1">&#x2022;</span>optimized fit</li>
              <li className="my-1 text-base lg:text-lg"><span className="text-white lg:text-base font-extrabold mr-1">&#x2022;</span>long lasting restorations</li>
            </ul>
            <p className="text-white my-4 text-sm">*For inlays, overlays, crowns and veneers.</p>
          </div>
        </div>
      </div>
      <p className="absolute mt-10 text-base bottom-4 right-4 text-white">*For inlays overlays, crowns & veneers.</p>
    </div>
  )
}

export default SingleVisitSlider


